import design from "../Assets/images/housemodel.jpg";
import construction from "../Assets/images/construction.jpg";
import interior from "../Assets/images/categoryImg/interior.jpeg";

const servicesData = [
  {
    slug: "planning",
    img: design,
    title: "Building Planning & 3D Design",
    description:
      "Professional architectural planning and modern 3D visualization to bring your vision to life before construction begins.",
    longDescription:
      "Detailed planning, drawings, approvals, and high-quality 3D designs before construction starts.",
  },
  {
    slug: "construction",
    img: construction,
    title: "Construction",
    description:
      "Complete construction services from foundation to finishing, ensuring quality workmanship and timely project completion.",
    longDescription:
      "End-to-end construction with quality materials, skilled labor, and strict timelines.",
  },
  {
    slug: "interior",
    img: interior,
    title: "Interior & Steel Designing",
    description:
      "Expert interior design and structural steel work for residential and commercial spaces.",
    longDescription:
      "Modern interiors, steel structures, space planning, and execution.",
  },
  {
    slug: "construction",
    img: construction,
    title: "Estimating, Costing & Supervision",
    description:
      "Accurate project estimation and professional site supervision.",
    longDescription:
      "Transparent costing, BOQ preparation, and site supervision throughout the project.",
  },
];

export default servicesData;
